// extracted by mini-css-extract-plugin
export default {"projectWrapper":"projectWrapper_t41v","showMore":"showMore_fwG2"};